module.exports = flarum.core.compat['utils/BasicEditorDriver'];